import React, { useEffect, useRef, useState } from 'react'
import ReactDatePicker from 'react-datepicker';
import calendarIcon from '../../assets/images/calendarIcon.png'
import './DatePicker.scss'
import moment from 'moment';

function DatePicker({value, onChange, placeholder, width, maxDate, backgroundColor, hasClearButton, onClear, disabled=false, className}) {
  const [currentDate, setCurrentDate] = useState(new Date());
  const currentDateRef = useRef(null)
  const boxRef = useRef(null)

  const handleDateChange = (date) => {
    setCurrentDate(date)
    currentDateRef?.current?.setState(prev => ({ ...prev, open: false }))
    if(onChange){
      onChange(date.toISOString())
    }
  };


  useEffect(()=>{
    if(value){
      setCurrentDate(value)
    }
  }, [value])

  useEffect(() => {
    function handleClick (){
      currentDateRef?.current?.setOpen(true)
    }

    if (boxRef?.current) {
      boxRef.current.getElementsByClassName('react-datepicker-wrapper')[0].addEventListener('click', handleClick);
    }

    return () => {
      if (boxRef?.current) {
        boxRef.current.getElementsByClassName('react-datepicker-wrapper')[0]?.removeEventListener('click', handleClick);
      }
    };
  }, []);

  return (
    <div className={`datePickerDiv-container  ${disabled ? 'disabled' : ''} ${className}`} ref={boxRef}  style={{width, backgroundColor}}>
        <div className='flex-grow-1 datepicker-label'>
          {!value ?
          <div className="dayDateTextDiv" ><p className="dayDateTextPlaceholder">Select</p></div>
          : <div className="dayDateTextDiv" ><p className="dayDateText">{(moment(value, "YYYY-MM-DD").format('DD/MM/YYYY'))}</p></div>
          }
        </div>
        {
          hasClearButton &&
          <span className="cross me-4" onClick={onClear}>
            {
              value
              &&
              <svg height="17" width="17" viewBox="0 0 20 20" aria-hidden="true" focusable="false" className="css-tj5bde-Svg"><path d="M14.348 14.849c-0.469 0.469-1.229 0.469-1.697 0l-2.651-3.030-2.651 3.029c-0.469 0.469-1.229 0.469-1.697 0-0.469-0.469-0.469-1.229 0-1.697l2.758-3.15-2.759-3.152c-0.469-0.469-0.469-1.228 0-1.697s1.228-0.469 1.697 0l2.652 3.031 2.651-3.031c0.469-0.469 1.228-0.469 1.697 0s0.469 1.229 0 1.697l-2.758 3.152 2.758 3.15c0.469 0.469 0.469 1.229 0 1.698z"></path></svg>
            }
          </span>
        }
        <ReactDatePicker
            disabled={disabled}
            selected={currentDate}
            onChange={date => { handleDateChange(date); }}
            popperPlacement={"bottom"}
            customInput={
                <img src={calendarIcon} width={'20px'} className="calIcon" alt="" />
            }
            {...maxDate && {maxDate: maxDate}}
            ref={currentDateRef}
            showYearDropdown={true}
            showMonthDropdown={true}
        />
    </div>
  )
}

export default DatePicker